export const placeholderList = [
  "Call to action to take part in a charity event for an animal rescue",
  "Promote a Zoo celebrating the birth of a baby elephant",
  "A luxury watch brand promoting a new collection inspired by the beauty of Paris",
  "Celebrate the engagement of a long time brand collaborator",
  "Black friday campaign for a restaurant serving BBQ meats",
  "An inspiring story about food served during the midsummer",
  "A holiday promotion for the most unique boutique hotel in town",
  "Story behind the most moving piece of art that you’ve seen at a museum",
  "Promotion of your athletic brand’s new line of activewear",
  "A local clothing boutique’s celebration of their 3rd anniversary since opening",
  "Hair care brand’s new temporary hair color product release",
  "Call to action to sign up for an herbalist’s email newsletter that focuses on recipes, education and local events",
  "Invite to join a makeup artist’s Instagram Live for Halloween makeup",
  "A day in the life of a landscape artist showing different hedge designs",
  "Show off the top 5 best airbnb’s in Nashville, Tennessee for bachelorette parties",
  "Inspire students to sign up for a local college fair",
];

export function getRandomCaptionPlaceholder() {
  return placeholderList[Math.floor(Math.random() * placeholderList.length)];
}
